<div
  class="flex justify-center"
  style="background: linear-gradient(180deg, #e8f0ff 22.4%, #ffffff 100%)"
>
  <div class="account-container">
    <div class="flex payment">
      <span class="iconContainer"><img src="/assets/images/IconSuccess.svg" class="icon" /></span>
      <span
        data-cy="confirmationHeading"
        class="confirmationHeading"
        dsContent
        [contentPath]="'billing.phoenixPayment.confirmationHeading'"
      ></span>
      <span
        data-cy="confirmationSubHeading"
        class="confirmationSubHeading"
        dsContent
        [contentPath]="'billing.phoenixPayment.confirmationSubHeading'"
      ></span>
      <div class="ctaContainer card">
        <ds-payment-details
          style="width: 100%"
          [data]="data"
          [riskDescription]="billAccountOptionFiltered[0]?.riskDescription"
          [isConfirmationPage]="true"
          [amountSubheading]="amountSubheading"
        />
      </div>
      <div class="ctaContainer">
        <call-to-action
          [fullWidthButtons]="true"
          [primaryButtonName]="primaryButtonName"
          (primaryEvent)="gotoAutopay()"
          [showPrimaryButton]="showAutopayButton"
          [secondaryButtonName]="secondaryButtonName"
          (secondaryEvent)="cancel()"
          style="width: 100%"
        ></call-to-action>
      </div>
      <amfam-confetti />
    </div>
  </div>
</div>
